
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import NumberInput from './NumberInput.vue'

@Component({
    name: 'template-designer-control',
    components: { NumberInput },
})
export default class DesignerControl extends Vue {
    @Prop({ type: Object }) template!: webpartv3.WebpartTemplate
    @Prop({ type: Boolean, default: true }) editMode!: boolean
    /**
     * 웹파트 템플릿 개인화를 위한 환경인지 여부
     * 개인화인 경우 일부 관리적 기능이 제한됨
     */
    @Prop({ type: Boolean, default: false }) personal!: boolean

    setCols(v: number) {
        this.$emit('cols', v)
    }

    setRows(v: number) {
        this.$emit('rows', v)
    }
}
